import React from 'react'

export default function Dropdown({title, options,name, value, handleChange}) {



  return (
   
        <div className="mb-3 ">
            <select className="form-select form-select-lg mb-3
            appearance-none
            block
            w-full
            px-4
            py-2
            text-xl
            font-normal
            text-gray-700
            bg-white bg-clip-padding bg-no-repeat
            border border-solid border-gray-300
            rounded
            transition
            ease-in-out
            m-0
            focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" aria-label=".form-select-lg example"
            name={name} value={value} onChange={handleChange} 
            
            >
                
                <option defaultValue>{title}</option>
                {
                    options.map(option => (
                        <option key={option}>{option}</option>

                        )
                    )
                }
                
            </select>

            
        </div>

  )
}
